import { IsNotEmpty } from 'class-validator';

export class UserProfile {
    @IsNotEmpty()
    firstName: string = '';
    @IsNotEmpty()
    lastName: string = '';
}
